module.exports = __webpack_public_path__ + "img/facebook.3794def8.png";